import { Table } from "antd";
import { NotFound } from "../../../../../sources/svg/svg";
import { useEffect, useState } from "react";
import { useDealer } from "../../../../../tools/api";
import { convertToJalaliWithTime } from "../../../../../tools/tools";

const ChargesHistory = ({ sppurchaseid = 0 }) => {
	const { queryDCPurchaseBySPPurchaseId } = useDealer();
	const [listCharge, setListCharge] = useState([]);

	//state current page show Records
	const [currentPage, setCurrentPage] = useState(0);
	// state totalRecord
	const [totalRecord, setTotalRecord] = useState(0);

	const [isLoadingList, setIsLoadingList] = useState(true);

	useEffect(() => {
		const initial = async () => {
			try {
				//#region charge
				setIsLoadingList(true);
				const payloadCharge = {
					SPPurchaseId: sppurchaseid,
					search: {
						sort: "",
						filter: "",
						entriesperpage: 10,
						page: currentPage === 0 ? 0 : currentPage - 1,
						totalrowcount: 0,
					},
				};
				const responseCharge = await queryDCPurchaseBySPPurchaseId(payloadCharge);
				if (responseCharge) {
					setListCharge(responseCharge.Result);
					setTotalRecord(responseCharge?.searchconfigmodel?.totalrowcount);
				}
				setIsLoadingList(false);
				//#endregion charge
			} catch (error) {
				setIsLoadingList(false);
				console.log(error?.message);
			}
		};
		if (sppurchaseid) initial();
	}, [sppurchaseid, currentPage]);
	return (
		<>
			<div className="holder-table" style={{ marginTop: "3rem" }}>
				<Table
					className="tbl-normal"
					loading={isLoadingList}
					columns={[
						{
							title: "مبلغ شارژ",
							dataIndex: "chargeamount",
							key: "chargeamount",
							width: 150,
						},
						{
							title: "تاریخ خرید",
							dataIndex: "purchasedate",
							key: "purchasedate",
							width: 150,
						},
						{
							title: "درگاه خرید",
							dataIndex: "paidtype",
							key: "paidtype",
							width: 150,
						},
						{
							title: "کاربر",
							dataIndex: "username",
							key: "username",
							width: 150,
						},
						{
							title: "وضعیت درخواست",
							dataIndex: "state",
							key: "state",
							width: 150,
						},
					]}
					locale={{
						emptyText: (
							<>
								<NotFound text={"رکوردی یافت نشد."} />
							</>
						),
					}}
					scroll={{ y: "100%" }}
					pagination={{
						className: "page-pagination",
						// position: [totalRecord.length > 10 ? "bottomLeft" : "none"],
						onChange: (page) => {
							setCurrentPage(page);
						},
						pageSize: 10,
						align: "start",
						current: currentPage === 0 ? 1 : currentPage,
						total: totalRecord,
						showSizeChanger: false,
					}}
					dataSource={listCharge.map((item, key) => ({
						key: key,
						chargeamount: item?.chargamount,
						purchasedate: convertToJalaliWithTime(item?.purchasedate),
						paidtype: item?.paidtype,
						username: item?.username || "-",
						state: item?.state,
					}))}
				/>
			</div>
		</>
	);
};

export default ChargesHistory;
